export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = [
    {code: 'en', socialLocale: 'en_US', label: 'English'},
    {code: 'ru', socialLocale: 'ru_RU', label: 'Русский'},
    {code: 'uk', socialLocale: 'uk_UA', label: 'Українська'},
    {code: 'pl', socialLocale: 'pl_PL', label: 'Polski'},
    {code: 'de', socialLocale: 'de_DE', label: 'Deutsch'},
    {code: 'fr', socialLocale: 'fr_FR', label: 'Français'},
    {code: 'it', socialLocale: 'it_IT', label: 'Italiano'},
    {code: 'es', socialLocale: 'es_ES', label: 'Español'},
    {code: 'pt', socialLocale: 'pt_PT', label: 'Português'},
    {code: 'nl', socialLocale: 'nl_NL', label: 'Nederlands'},
    {code: 'sv', socialLocale: 'sv_SE', label: 'Svenska'},
    {code: 'da', socialLocale: 'da_DK', label: 'Dansk'},
    {code: 'nb', socialLocale: 'nb_NO', label: 'Norsk bokmål'},
    {code: 'fi', socialLocale: 'fi_FI', label: 'Suomi'},
    {code: 'et', socialLocale: 'et_EE', label: 'Eesti'},
    {code: 'lv', socialLocale: 'lv_LV', label: 'Latviešu'},
    {code: 'lt', socialLocale: 'lt_LT', label: 'Lietuvių'},
    {code: 'hu', socialLocale: 'hu_HU', label: 'Magyar'},
    {code: 'el', socialLocale: 'el_GR', label: 'Ελληνικά'},
    {code: 'ro', socialLocale: 'ro_RO', label: 'Română'},
    {code: 'hr', socialLocale: 'hr_HR', label: 'Hrvatski'},
    {code: 'sl', socialLocale: 'sl_SI', label: 'Slovenščina'},
    {code: 'bg', socialLocale: 'bg_BG', label: 'Български'},
    {code: 'sr', socialLocale: 'sr_RS', label: 'Српски'},
    {code: 'bs', socialLocale: 'bs_BA', label: 'Bosanski'},
    {code: 'cnr', label: 'Crnogorski'},
    {code: 'mk', socialLocale: 'mk_MK', label: 'Македонски'},
    {code: 'tr', socialLocale: 'tr_TR', label: 'Türkçe'},
].sort((a, b) => a.label.localeCompare(b.label, 'en'));

export const NON_DEFAULT_LANGUAGE_CODES = LANGUAGES.map((l) => l.code).filter((code) => code !== DEFAULT_LANGUAGE);

export function isSupportedLanguage(code) {
    return code === DEFAULT_LANGUAGE || NON_DEFAULT_LANGUAGE_CODES.includes(code);
}

export function localePath(path, lang) {
    if (!lang || lang === DEFAULT_LANGUAGE) {
        return path;
    }
    if (path === '/') {
        return `/${lang}`;
    }
    if (path.startsWith('/#') || path.startsWith('/?')) {
        return `/${lang}${path.slice(1)}`;
    }
    return `/${lang}${path}`;
}

export function stripLangPrefix(pathname, lang) {
    if (!lang || lang === DEFAULT_LANGUAGE) {
        return pathname || '/';
    }
    const prefix = `/${lang}`;
    if (pathname === prefix) {
        return '/';
    }
    if (pathname.startsWith(`${prefix}/`)) {
        return pathname.slice(prefix.length);
    }
    return pathname;
}

export function languageSwitchPath(logicalPath, lang, search = '', hash = '') {
    if (logicalPath === '/blog' || logicalPath.startsWith('/blog/')) {
        return localePath('/blog', lang);
    }
    return localePath(logicalPath, lang) + search + hash;
}

// Intl has no dedicated cnr locale; use the Latin-script locale for Montenegro.
export function intlLocale(language) {
    return language === 'cnr' ? 'sr-Latn-ME' : language;
}
